import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRequestService {
  private assetUrl = environment.assetUrl;

  constructor(private http: HttpClient) {}

  // ============================================
  // FORM TEMPLATE APIs
  // ============================================

  getFormTemplates(params?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/maintenance-request-form-templates/`;
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  getFormTemplateById(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/maintenance-request-form-templates/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getDefaultFormTemplate(): Observable<any> {
    const url = `${this.assetUrl}/api/v1/maintenance-request-form-templates/default`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  // ============================================
  // MAINTENANCE REQUEST CRUD APIs
  // ============================================

  createMaintenanceRequest(data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-maintenance-requests/`;
    return this.http.post<any>(url, data, { withCredentials: true });
  }

  getMaintenanceRequests(filters?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-maintenance-requests/`;
    let params = new HttpParams();
    if (filters) {
      if (filters.limit) params = params.set('limit', filters.limit.toString());
      if (filters.offset !== undefined) params = params.set('offset', filters.offset.toString());
      if (filters.status) params = params.set('status', filters.status);
      if (filters.priority) params = params.set('priority', filters.priority);
      if (filters.asset_id) params = params.set('asset_id', filters.asset_id);
      if (filters.search) params = params.set('search', filters.search);
      if (filters.subsidiary_id) params = params.set('subsidiary_id', filters.subsidiary_id);
      if (filters.location_id) params = params.set('location_id', filters.location_id);
      if (filters.request_date) params = params.set('request_date', filters.request_date);
      if (filters.request_id) params = params.set('request_id', filters.request_id);
      if (filters.get_references) params = params.set('get_references', filters.get_references);
      if (filters.created_by) params = params.set('created_by', filters.created_by);
      if (filters.assign_to_user_id) params = params.set('assign_to_user_id', filters.assign_to_user_id);
    }
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  getMaintenanceRequest(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-maintenance-requests/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  updateMaintenanceRequest(id: string, data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-maintenance-requests/${id}`;
    return this.http.put<any>(url, data, { withCredentials: true });
  }

  deleteMaintenanceRequest(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-maintenance-requests/${id}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }
}
